/**
 * apiFetch - universal fetch for dev/prod that prefixes API calls with the correct base URL
 *
 * Usage:
 *   apiFetch('/users', { method: 'GET' })
 *   apiFetch('https://external.com/endpoint') // untouched
 */
export async function apiFetch(input, init) {
  let url = input;

  // If input is a string and is a relative API path, prefix with base URL.
  if (typeof input === 'string') {
    if (input.startsWith('/api/')) {
      // NEXT_PUBLIC_BASE_PATH is only set for module containers
      // (e.g. "/modules/{slug}"). On the main app it is UNSET → must fall back
      // to "" — otherwise `undefined + "/api/..."` produced the literal
      // "/undefined/api/..." path → 404 (broke password reset). Guard with "".
      const base = process.env.NEXT_PUBLIC_BASE_PATH || '';
      url = base + (input.startsWith('/') ? input : '/' + input);
    }
  }
  // If input is a Request object, you could extend logic here if needed

  return fetch(url, init);
}

export function getClientIP(request) {
  return (
    request.headers.get('x-forwarded-for') ||
    request.headers.get('x-real-ip') ||
    //|| request.socket.remoteAddress
    'unknown'
  );
}
